import { z } from 'zod';
import { type MotivoRejeicaoIndicacao, motivoRejeicaoIndicacaoSchema } from './erros.js';

/** Dry-run das 8 regras da §5.1 (`POST /codigos/validar`). */
export const validarCodigoSchema = z.object({
  codigo: z.string().trim().min(1),
  /** cliente candidato a indicado; se omitido, valida só o código (regras 1 e 2) */
  clienteId: z.string().uuid().optional(),
  /** necessário para a regra 3 quando não há `clienteId` cadastrado ainda */
  clienteNovo: z.boolean().optional(),
});
export type ValidarCodigoInput = z.infer<typeof validarCodigoSchema>;

/**
 * Resposta de `POST /v1/codigos/validar` (UX-PAINEL-INTERNO §4). `valido: true` →
 * chip verde com o primeiro nome do indicador; `false` → a frase do dicionário
 * §4.4 a partir de `motivo`.
 */
export const validarCodigoRespostaSchema = z.discriminatedUnion('valido', [
  z.object({
    valido: z.literal(true),
    indicador: z.object({ id: z.string(), nome: z.string() }),
    nivelIndicador: z.number().int(),
  }),
  z.object({
    valido: z.literal(false),
    motivo: motivoRejeicaoIndicacaoSchema,
  }),
]);
export type ValidarCodigoResposta = z.infer<typeof validarCodigoRespostaSchema>;

export const listarIndicacoesQuerySchema = z.object({
  status: z.enum(['convertida', 'rejeitada']).optional(),
  indicadorClienteId: z.string().uuid().optional(),
  pagina: z.coerce.number().int().positive().default(1),
  limite: z.coerce.number().int().positive().max(100).default(20),
});
export type ListarIndicacoesQuery = z.infer<typeof listarIndicacoesQuerySchema>;

/** Texto legível de cada motivo de rejeição, para o painel (SPEC §5.1). */
export const MOTIVO_REJEICAO_LABEL: Record<MotivoRejeicaoIndicacao, string> = {
  codigo_inexistente: 'O código informado não existe.',
  codigo_inativo: 'O código está inativo ou expirado.',
  nao_e_cliente_novo: 'A pessoa indicada já era cliente da Varga — não gera brinde.',
  mesmo_contato: 'O telefone do indicado é igual ao do indicador (autoindicação).',
  mesmo_documento: 'O documento do indicado é igual ao do indicador (autoindicação).',
  ja_indicado: 'Esta pessoa já tem uma indicação convertida.',
  indicador_inativo: 'O indicador está inativo.',
  campanha_encerrada: 'A campanha já foi encerrada.',
};
